import React from 'react'
import Navbar from '../components/navigationbar/Navbar'
import FadedImageSlider from '../components/FadeimageSlider/FadeImageSlider'
import CommitteeMembers from './CommitteeMembers/CommitteeMembers'
import BodyMembersCard from '../components/bodyMembersSection/BodyMemberscards'
import './Home.css'
import Donation from '../components/DonationSection/DonationSection'
import UpcomingEvents from '../components/UpcomingEvents/UpcomingEvents'
import Activity from '../components/ActivitiesSection/Activity'
import Advertisement from '../components/AdvertisementSection/Advertisement'
import Footer from '../components/Footer/Footer'
import Registrationbutton from '../components/RegistrationSection/Registrationbutton'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../Pages/AuthContext';
import GPCON_Reviews from '../components/ReviewSection/GPCON_Reviews'
import GPCONGallaryButton from '../components/ReviewSection/GPCONGallaryButton'


function Home() {

    const Navigate=useNavigate();
    const { isLoggedIn, userData } = useAuth();
    return (
        <>
            <Navbar />
            <FadedImageSlider />
            <BodyMembersCard />
            <div className="Registration-box">
                <div className='registration-box-content'>
                    Embark on a journey of impact and companionship. Join the GP Association of Ichalkaranji and be the heartbeat of change in healthcare.
                </div>

                <div className="registration-btns">
                <div className="register-btn" onClick={()=>{
                    {isLoggedIn ? (
                   Navigate('/RegistrationForm')
                ) : (
                    Navigate('/login')
                )}
                }}>
                    Register Now
                </div>
                
                <div className="register-btn" onClick={()=>{
                   Navigate('/CMERequest')
                }}>
                    Register for CME
                </div>   
                </div>
               
            </div>
        
            <GPCONGallaryButton/>
            <Activity />
            
            <GPCON_Reviews/>
            <Donation />
            
            <Advertisement />
            <UpcomingEvents />
            
            <Footer/>

        </>
    )
}

export default Home
